// import React from "react";
// import pimg1 from '../../images/partners/5F_Ministries.png'
// import pimg2 from '../../images/partners/KLOAK_Solutions.png'
// import pimg3 from '../../images/partners/LANCH_Construction.png'
// import pimg4 from '../../images/partners/StrategySync.png'
// import pimg5 from '../../images/partners/Doxa-Foundation.png'
//
// const partners = [
//     {
//         pImg: pimg4,
//     },
//     {
//         pImg: pimg2,
//     },
//     {
//         pImg: pimg3,
//     },
//     {
//         pImg: pimg1,
//     },
//     {
//         pImg: pimg5,
//     },
// ];
//
//
//
// const PartnerSection2 = (props) => {
//
//     return (
//
//         <section className="partner-section-s2">
//             <div className="container">
//                 <div className="row">
//                     <hr className="my-8 border-gray-300"/>
//
//                     {/*<div className="col col-lg-5 col-12">*/}
//                     <div>
//                         <div className="section-title">
//                             <span>#Partners</span>
//                             <h2>Our Partners</h2>
//                         </div>
//                         <div className="col col-lg-7 col-12">
//                             <div className="partners-area clearfix">
//                                 {partners.map((partner, pitem) => (
//                                     <div key={pitem}>
//                                         <img src={partner.pImg} alt=""/>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//
//                         <div className="partner-details">
//                             <div className="section-title">
//                                 <span>StrategySync</span>
//                             </div>
//                             <p>StrategySync is a strategic partner offering business intelligence and operational
//                                 support to enhance our foundation’s efficiency and impact. Their expertise in
//                                 customer
//                                 experience management, business consulting, project management, and IT services
//                                 ensures
//                                 that our initiatives are executed with strategic clarity and aligned with our
//                                 long-term
//                                 goals.</p>
//                         </div>
//
//                         <hr className="my-8 border-gray-300"/>
//                         <div className="partner-details">
//                             <div className="section-title">
//                                 <span>KLOAK Solutions</span>
//                             </div>
//                             <p>KLOAK Solutions is a vital financial partner supporting our mission through generous
//                                 funding. With a core focus on adult healthcare services such as private duty nursing,
//                                 companion care, and live-in support, they extend their impact by enabling our programs
//                                 to grow and reach more people in need.</p>
//                         </div>
//
//                         <hr className="my-8 border-gray-300"/>
//                         <div className="partner-details">
//                             <div className="section-title">
//                                 <span>LANCH Construction</span>
//                             </div>
//                             <p>LANCH Construction is an emerging leader in construction and renovation, helping us build
//                                 and maintain the infrastructure essential for our community-centered projects.
//                                 Specializing in construction, renovations, and repairs, LANCH contributes expert
//                                 manpower and financial backing to ensure our projects are sustainable and built to
//                                 last.</p>
//                         </div>
//
//                         <hr className="my-8 border-gray-300"/>
//                         <div className="partner-details">
//                             <div className="section-title">
//                                 <span>5 Foundations Ministries</span>
//                             </div>
//                             <p>5 Foundations Ministries is a Christian ministry dedicated to strengthening our spiritual
//                                 and humanitarian mission. Through evangelism, spiritual guidance, and community
//                                 outreach, they inspire hope, mobilize volunteers, and reinforce the shared values that
//                                 guide our work in the communities we serve.</p>
//                         </div>
//
//                         <hr className="my-8 border-gray-300"/>
//                         <div className="partner-details">
//                             <div className="section-title">
//                                 <span>Doxa Foundation Internationale</span>
//                             </div>
//                             <p>Doxa Foundation Internationale is a Christian humanitarian organization dedicated to
//                                 serving the people of Haiti through transformative initiatives. With a focus on
//                                 agricultural development, school construction, educational financial aid, evangelism,
//                                 and micro-credit programs, this devoted partner provides critical resources and
//                                 expertise that empower individuals and uplift entire communities.</p>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// }
//
// export default PartnerSection2;

import React, { useState } from "react";
import pimg1 from '../../images/partners/5F_Ministries.png'
import pimg2 from '../../images/partners/KLOAK_Solutions.png'
import pimg3 from '../../images/partners/LANCH_Construction.png'
import pimg4 from '../../images/partners/StrategySync.png'
import pimg5 from '../../images/partners/Doxa-Foundation.png'

const partners = [

    {
        pImg: pimg2,
        name: "KLOAK Solutions",
        description: "KLOAK Solutions is a vital financial partner supporting our mission through generous funding. With a core focus on adult healthcare services such as private duty nursing, companion care, and live-in support, they extend their impact by enabling our programs to grow and reach more people in need."
    },
    {
        pImg: pimg5,
        name: "Doxa Foundation Internationale",
        description: "Doxa Foundation Internationale is a Christian humanitarian organization dedicated to serving the people of Haiti through transformative initiatives. With a focus on agricultural development, school construction, educational financial aid, evangelism, and micro-credit programs, this devoted partner provides critical resources and expertise that empower individuals and uplift entire communities."
    },
    {
        pImg: pimg1,
        name: "5 Foundations Ministries",
        description: "5 Foundations Ministries is a Christian ministry dedicated to strengthening our spiritual and humanitarian mission. Through evangelism, spiritual guidance, and community outreach, they inspire hope, mobilize volunteers, and reinforce the shared values that guide our work in the communities we serve."
    },
    {
        pImg: pimg4,
        name: "StrategySync",
        description: "StrategySync is a strategic partner offering business intelligence and operational support to enhance our foundation’s efficiency and impact. Their expertise in customer experience management, business consulting, project management, and IT services ensures that our initiatives are executed with strategic clarity and aligned with our long-term goals."
    },
    {
        pImg: pimg3,
        name: "LANCH Construction",
        description: "LANCH Construction is an emerging leader in construction and renovation, helping us build and maintain the infrastructure essential for our community-centered projects. Specializing in construction, renovations, and repairs, LANCH contributes expert manpower and financial backing to ensure our projects are sustainable and built to last."
    },
];

const PartnerSection2 = () => {
    const [selectedPartner, setSelectedPartner] = useState(null);

    const handleCloseModal = () => setSelectedPartner(null);

    return (
        <section className="partner-section-s2">
            <div className="container">
                <div className="row">
                    <hr className="my-8 border-gray-300" />
                    <div>
                        <div className="section-title">
                            <span>#Partners</span>
                            <h2>Our Partners</h2>
                        </div>
                        <div className="col col-lg-7 col-12">
                            <div className="partners-area" style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                                {partners.map((partner, index) => (
                                    <div
                                        key={index}
                                        style={{ textAlign: 'center', maxWidth: '200px', cursor: 'pointer' }}
                                        onClick={() => setSelectedPartner(partner)}
                                    >
                                        <img
                                            src={partner.pImg}
                                            alt={partner.name}
                                            className="partner-image"
                                        />
                                        <button
                                            style={{
                                                marginTop: '10px',
                                                background: 'none',
                                                color: '#022267',
                                                border: 'none',
                                                cursor: 'pointer',
                                                textDecoration: 'underline'
                                            }}
                                        >
                                            Read more
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal */}
            {selectedPartner && (
                <div className="modal-overlay" onClick={handleCloseModal}>
                    <div
                        className="modal-content animate-in"
                        onClick={e => e.stopPropagation()}
                    >
                        <button onClick={handleCloseModal} className="close-button">&times;</button>
                        <h3>{selectedPartner.name}</h3>
                        <p>{selectedPartner.description}</p>
                    </div>
                </div>
            )}

            {/* Styles */}
            <style>{`
                .partner-image {
                    width: 100%;
                    border-radius: 8px;
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
                }

                .partner-image:hover {
                    transform: translateY(-6px);
                    box-shadow: 0 6px 20px rgba(0,0,0,0.2);
                }

                .modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    background-color: rgba(0, 0, 0, 0.6);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1000;
                    animation: fadeIn 0.3s ease-in-out;
                }

                .modal-content {
                    background-color: #fff;
                    padding: 25px;
                    border-radius: 10px;
                    max-width: 500px;
                    width: 90%;
                    position: relative;
                    transform: scale(0.9);
                    opacity: 0;
                    animation: popIn 0.3s forwards ease-in-out;
                }

                .close-button {
                    position: absolute;
                    top: 10px;
                    right: 15px;
                    background: none;
                    border: none;
                    font-size: 24px;
                    cursor: pointer;
                }

                @keyframes popIn {
                    from {
                        transform: scale(0.9);
                        opacity: 0;
                    }
                    to {
                        transform: scale(1);
                        opacity: 1;
                    }
                }

                @keyframes fadeIn {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }
            `}</style>
        </section>
    );
};

export default PartnerSection2;

